import en from './en.json'
import it from './it.json'

export const flagsTranslations = {
	en,
	it
} as const
